/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Card, CardBody, Flex, Heading } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useUser } from "../../hooks/use-user";
import { useGetLocation } from "../../services/locations-apis";
import { ServicePointDetails } from "../../components/servicePoints/service-point-details";

export default function ServicePointDetailsView() {
  const [servicePoint, setServicePoint] = useState({});
  const user = useUser();
  const params = useParams();
  const {
    mutate: getLocation,
    data: getLocationRes,
    isPending: gettingLocation,
    error: locationError,
  } = useGetLocation();

  useEffect(() => {
    if (getLocationRes) {
      setServicePoint(getLocationRes.data);
    }
  }, [getLocationRes, locationError]);
  useEffect(() => {
    if (params.locationId) {
      getLocation(params.locationId);
    }
  }, []);
  const canEdit = useMemo(() => {
    return HasPermission(user, "ServicePoint", "Edit");
  }, [user]);
  return (
    <>
      {gettingLocation ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Service Points", link: Paths.locations },
            { text: "Service Point Details", isCurrentPage: true },
          ]}
        />

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Flex w="100%" justify="space-between" flexDirection="row">
                <Heading>{servicePoint.locationName}</Heading>
                {canEdit ? (
                  <Button
                    as={Link}
                    to={`${Paths.editLocations}/${servicePoint.servicePointId}`}
                  >
                    Edit
                  </Button>
                ) : (
                  <></>
                )}
              </Flex>
              <div className="add-location-form">
                {servicePoint.id || servicePoint.servicePointId ? (
                  <ServicePointDetails servicePoint={servicePoint} />
                ) : (
                  <></>
                )}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
